module.exports = __webpack_public_path__ + "static/media/me.7741456e.jpg";